import { FORM_OFFICE_API_VALUES, type FormOfficeApi } from "@/src/utils/tasks/normalizeFormOfficeForApi";
import type { AdmissionOfficeCountry } from "@/src/utils/admissionOffice/resolveAdmissionOfficeRouteFromTask";

/** Roles with unrestricted country / Admissions Office tab access. */
export const FULL_COUNTRY_ACCESS_ROLES = [
  "admin",
  "sub-admin",
  "application-hr",
  "documents-hr",
] as const;

export type FullCountryAccessRole = (typeof FULL_COUNTRY_ACCESS_ROLES)[number];

export const SIDEBAR_SITE_OPTIONS = ["https://feu.com.ua/", "https://ieu.com.pl/"] as const;

export type SidebarSiteOption = (typeof SIDEBAR_SITE_OPTIONS)[number];

// =============================================================================
// TEMPORARY: All option (no site filter) — for convenient viewing of all data.
// To restore production behavior (no All, always first URL by index):
//   1) uncomment the "RESTORE WITHOUT All" blocks below
//   2) remove / comment the "TEMPORARY WITH All" blocks
// =============================================================================

// --- TEMPORARY WITH All ---
/** Display label for “no site filter” — maps to empty `selectedSiteUrl`. */
export const SIDEBAR_SITE_ALL_LABEL = "All";

/** Options shown in sidebar-office (All + concrete URLs). */
export const SIDEBAR_SITE_SELECT_OPTIONS = [SIDEBAR_SITE_ALL_LABEL, ...SIDEBAR_SITE_OPTIONS] as const;

/** Default = All (empty string, no site filter). */
export const getDefaultSidebarSiteUrl = (): string => "";

/** Map stored/selected value ↔ autocomplete display text. */
export const toSidebarSiteDisplayValue = (siteUrl: string): string => {
  const trimmed = String(siteUrl ?? "").trim();
  return trimmed || SIDEBAR_SITE_ALL_LABEL;
};

export const fromSidebarSiteDisplayValue = (display: string): string => {
  const trimmed = String(display ?? "").trim();
  if (!trimmed || trimmed === SIDEBAR_SITE_ALL_LABEL) return "";
  return trimmed;
};
// --- end TEMPORARY WITH All ---

// --- RESTORE WITHOUT All (production) ---
// export const SIDEBAR_SITE_SELECT_OPTIONS = [...SIDEBAR_SITE_OPTIONS] as const;
//
// /** Always the first available option by index — not a hardcoded URL. */
// export const getDefaultSidebarSiteUrl = (): SidebarSiteOption => SIDEBAR_SITE_OPTIONS[0];
//
// export const toSidebarSiteDisplayValue = (siteUrl: string): string =>
//   String(siteUrl ?? "").trim() || getDefaultSidebarSiteUrl();
//
// export const fromSidebarSiteDisplayValue = (display: string): string => {
//   const trimmed = String(display ?? "").trim();
//   return trimmed || getDefaultSidebarSiteUrl();
// };
// --- end RESTORE WITHOUT All ---

export const OFFICE_TO_ADMISSION_COUNTRY: Record<FormOfficeApi, AdmissionOfficeCountry> = {
  MALTA: "malta",
  UKRAINE: "ukraine",
  POLAND: "poland",
};

export const ADMISSION_COUNTRY_TO_OFFICE: Record<AdmissionOfficeCountry, FormOfficeApi> = {
  malta: "MALTA",
  ukraine: "UKRAINE",
  poland: "POLAND",
};

export const ALL_FORM_OFFICES: FormOfficeApi[] = [...FORM_OFFICE_API_VALUES];
